module.exports = {
  title: '水精灵五金',
  route: {
    path: 'index',
    children: {
      path: '',
    },
  },
};
